import React from 'react';
import '../stylesheets2025/Themes.css';
import themeWater from '../images/core/theme-water.png';
import themeEnergy from '../images/core/theme-energy.png';
import themeWaste from '../images/core/theme-waste.png';
import themeClimate from '../images/core/theme-climate.png';

const Themes = () => {
  const themes = [
    {
      title: 'Water',
      caption: 'Management, conservation & circular use of water resources.',
      imageUrl: themeWater,
    },
    {
      title: 'Energy',
      caption: 'Renewable energy, storage, and sustainable power systems.',
      imageUrl: themeEnergy,
    },
    {
      title: 'Waste Management',
      caption: 'Recycling, recovery, and responsible material flows.',
      imageUrl: themeWaste,
    },
    {
      title: 'Climate',
      caption: 'Climate action, resilience, and low-carbon solutions.',
      imageUrl: themeClimate,
    },
  ];

  return (
    <div className="themes-container">
      <div className="themes-grid themes-grid--core">
        {themes.map((theme) => (
          <article className="theme-card" key={theme.title}>
            <div className="theme-image-wrap">
              <img
                src={theme.imageUrl}
                alt={theme.title}
                className="theme-image"
              />
            </div>
            <div className="theme-text">
              <h3 className="theme-heading dgreen">{theme.title}</h3>
              {/* <p className="theme-caption">{theme.caption}</p> */}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Themes;
